<template>

<div>
<v-container class="my-5">
        
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3  v-for="sa in serviceAccounts" :key="sa.name">
                <v-card hover flat class="text-xs-center ma-3">
                 <div class="primary subheading text-uppercase white--text">Service Account</div>
                    <v-responsive class="pt-4">
                            <v-img :src="sa.packagesIsp.customer.logo"
                            max-height="80"
                            aspect-ratio="1.4"
                            contain=true
                            ></v-img>
                    </v-responsive>
                    <v-card-text>
                        <h4>ISP Package Details:</h4>
                        <div class="grey--text">Package Name: {{sa.packagesIsp.name}}</div>
                        <div class="grey--text">Term: {{sa.packagesIsp.term}}</div>
                        <div class="grey--text">Activation Date: {{formatDate(sa.activationDate)}}</div>
                        <div class="grey--text">Contractual Package Expiration: {{formatDate(calculateEndDate(sa.activationDate, sa.packagesIsp.term))}}</div>

                        <v-divider></v-divider>
                        <div class="grey--text">Auth protocol: {{sa.authenticationType}}</div>
                        <div class="grey--text">Username: {{sa.pppoeUsername}}</div> 
                        <div class="grey--text">Password: {{sa.pppoePassword}}</div>
                        <v-divider></v-divider>
                        <div class="grey--text">FNO Package: {{sa.packagesIsp.packagesFno.packageCode}}</div>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>


</div>
</template>

<script>
import dateformat from 'dateformat';
export default {
        props:['serviceAccounts'],
        
    methods:{
            formatDate(date){
                return dateformat(date,'dd/mm/yyyy')
            },
            calculateEndDate(startDate, term){
                startDate =new Date(startDate)
                if(term==="6 month"){
                    term=6;
                    startDate.setMonth(startDate.getMonth()+(term))
                }
                if(term==="12 month"){
                    term=12;
                    startDate.setMonth(startDate.getMonth()+(term))
                }
                if(term==="24 month"){
                    term=24;
                    startDate.setMonth(startDate.getMonth()+(term))
                }
                if(term==='month-to-month'){
                    term=0;
                    var endContractDate = new Date(startDate.getFullYear(), startDate.getMonth()+2,0);
                    }
                return endContractDate
            }
        }
}
</script>

